import {withIMask} from './components/withIMask';
import {SpartanTextField} from './SpartanTextField';

export const SpartanCreditField = withIMask(SpartanTextField, {mask: '0000 0000 0000 0000'});
